/**
 * Label pro field, pokud se fieldy použijí s label=false, lze pro zobrazení jejich labelu použít tuto komponentu.
 * Label se případně přeloží (pokud je pole (seznam stringů) nebo string).
 * Použití:
 * <FieldLabel label="aaaaaaa"/>
 */
import React from 'react'
import {Label} from "reactstrap";
import TranslateComponent from './TranslateComponent';

export default class extends React.Component {
    static propTypes = {
        component: React.PropTypes.oneOf([React.PropTypes.string, React.PropTypes.array, React.PropTypes.element, React.PropTypes.bool]),   // komponenta pro label, pokud je vstupem pole nebo string - převádí se přes TranslateComponent, standardně Label
        label: React.PropTypes.oneOf([React.PropTypes.string, React.PropTypes.array])
    };

    static defaultProps = {
        component: Label
    };

    render() {
        const {label, component, ...other} = this.props;

        let labelComponent;
        if (Array.isArray(label) || typeof label === 'string') {
            let labelProps = {
                message: label,
                component,
                ...other
            };

            labelComponent = <TranslateComponent {...labelProps} />
        } else {
            labelComponent = label;
        }

        return labelComponent;
    }
}
